import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* Same IDs that already run on stresslessdogs.nl. Loaded as gtag directly
   rather than via GTM-5CJ22CJ, so no triggers built for that domain can
   fire here by accident. */
const GOOGLE_ADS_ID = 'AW-649210165';
const GA4_ID = 'G-LTTKB8L6K8';
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
export function GoogleTag() {
  const {
    pathname,
    search
  } = useLocation();
  useEffect(() => {
    if (window.gtag) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    /* Route changes send their own page_view below, so the automatic one
       would double-count the landing page. */
    window.gtag('config', GA4_ID, {
      send_page_view: false
    });
    window.gtag('config', GOOGLE_ADS_ID);
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
    if (!window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [pathname, search]);
  return null;
}